import { NAMESPACES } from "@/redux/collaboration/constants";

import { createApi } from "./common";

export const saveMessageWithFiles = (namespace, data) => {
  const token = JSON.parse(localStorage.getItem("auth"));

  const API_URL = {
    [NAMESPACES.ORDER]: "collaborate_attachments/",
    [NAMESPACES.PURCHASE_ORDER]: "collaborate_attachments/",
    [NAMESPACES.SUPPLIER]: "collaborate_attachments/",
    [NAMESPACES.CUSTOMER]: "collaborate_attachments/",
    [NAMESPACES.PRODUCT]: "collaborate_attachments/",
  };

  return createApi("POST", API_URL?.[namespace])(token, data);
};

export const toggleAttachment = ({ attachmentType, fileId }) => {
  const token = JSON.parse(localStorage.getItem("auth"));

  return createApi("PUT", `collaborate_attachments/${attachmentType}/${fileId}/toggle/`)(token);
};

export const uploadAttachment = (data) => {
  const token = JSON.parse(localStorage.getItem("auth"));
  return createApi("POST", "upload_file/")(token, data);
};

export const getAttachmentFiles = (fileId) => {
  const token = JSON.parse(localStorage.getItem("auth"));

  return createApi("GET", `collaborate_attachments/${fileId}/`, {
    responseType: "blob",
  })(token);
};

export const downloadFilesAsZip = (messageId, fileIds = []) => {
  const token = JSON.parse(localStorage.getItem("auth"));
  const params = new URLSearchParams({ message_id: messageId });

  if (fileIds.length > 0) {
    params.append("file_ids", fileIds.join(","));
  }

  return createApi("GET", `collaborate_attachments/download-zip?${params}`, {
    responseType: "blob",
  })(token);
};

export const bulkDeleteFiles = (messageId, fileIds = []) => {
  const token = JSON.parse(localStorage.getItem("auth"));
  const params = new URLSearchParams({ message_id: messageId });

  if (fileIds.length > 0) {
    params.append("file_ids", fileIds.join(","));
  }

  return createApi("DELETE", `collaborate_attachments/bulk-delete?${params}`)(token);
};

export const bulkRestoreFiles = (messageId, fileIds = []) => {
  const token = JSON.parse(localStorage.getItem("auth"));
  const params = new URLSearchParams({ message_id: messageId });

  if (fileIds.length > 0) {
    params.append("file_ids", fileIds.join(","));
  }

  return createApi("POST", `collaborate_attachments/bulk-restore?${params}`)(token);
};

export const bulkLabelFiles = (messageId, labelUid, fileIds) => {
  const token = JSON.parse(localStorage.getItem("auth"));

  return createApi("POST", "collaborate/label-attachments/attach/")(token, {
    message_id: messageId,
    label_uid: labelUid,
    file_ids: fileIds,
  });
};

export const bulkDetachLabelFiles = (attachmentIds) => {
  const token = JSON.parse(localStorage.getItem("auth"));

  return createApi("DELETE", "collaborate/label-attachments/detach/")(token, {
    attachment_ids: attachmentIds,
  });
};
